import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  // Constante computada a partir do tipo do tema atual (MUI v4)
  const isDark = theme.palette.type === 'dark'

  return {
    root: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    multField: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: '5px'
    },
    multFieldLine: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& > *:not(:last-child)': {
        marginRight: theme.spacing(1)
      }
    },

    btnWrapper: {
      position: 'relative'
    },

    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120
    },
    dialogTitle: {
      color: theme.palette.blue_300.main
    },
    radio: {
      '&.MuiRadio-root': {
        color: theme.palette.blue_300.main,
        padding: 0,
        marginRight: 4
      },
      '& .MuiSvgIcon-root': {
        fontSize: 18
      },
      '&.Mui-checked': {
        color: theme.palette.blue_300.main
      }
    },
    label: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      marginBottom: 8,
      fontSize: '1rem'
    },
    // Exemplo para o container do preview que criamos anteriormente
    previewContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '8px 16px',
      borderRadius: '8px',
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      backgroundColor: isDark ? theme.palette.dark_400.main : '#F8F9FA',
      marginBottom: '16px'
    },
    previewColor: {
      border: '1px solid',
      padding: '0 14px',
      borderRadius: '4px',
      fontSize: '0.875rem',
      minWidth: '60px',
      textAlign: 'center',
      textTransform: 'uppercase'
    },
    swatchColors: {
      display: 'grid',
      gridTemplateColumns: 'repeat(10,1fr)',
      gap: '4px'
    },
    colorAdorment: {
      borderRadius: '8px',
      width: '32px',
      height: '32px',
      cursor: 'pointer',
      boxSizing: 'border-box',
      outline: 'none',
      transition: 'transform 0.1s ease'
    },

    optionsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      marginTop: 8,
      flexWrap: 'wrap',
      '& .MuiFormControlLabel-root': {
        color:
          theme.palette.type === 'dark'
            ? theme.palette.dark_50.main
            : theme.palette.gray_400.main,
        margin: '0 !important'
      }
    },
  }
})
